"use strict";

var rfb;

function setPassword () {
    rfb.sendPassword($D('password_input').value);
    return false;
}
function sendCtrlAltDel () {
    rfb.sendCtrlAltDel();
    return false;
}
function xvpShutdown () {
    rfb.xvpShutdown();
    return false;
}
function xvpReboot () {
    rfb.xvpReboot();
    return false;
}
function xvpReset () {
    rfb.xvpReset();
    return false;
}
function updateState (rfb, state, oldstate, msg) {
    var s, sb, cad, level;
    s = $D('noVNC_status');
    sb = $D('noVNC_status_bar');
    cad = $D('sendCtrlAltDelButton');
    switch (state) {
        case 'failed':
            level = "error";
            break;
        case 'fatal':
            level = "error";
            break;
        case 'normal':
            level = "normal";
            break;
        case 'disconnected':
            level = "normal";
            break;
        case 'loaded':
            level = "normal";
            break;
        default:
            level = "warn";
            break;
    }

    if (state === "normal") {
        cad.disabled = false;
    } else {
        cad.disabled = true;
        xvpInit(0);
    }

    if (typeof(msg) !== 'undefined') {
        sb.setAttribute("class", "noVNC_status_" + level);
        s.innerHTML = msg;
    }
}

function xvpInit (ver) {
    var xvpbuttons;
    xvpbuttons = $D('noVNC_xvp_buttons');
    if (ver >= 1) {
        xvpbuttons.style.display = 'inline';
    } else {
        xvpbuttons.style.display = 'none';
    }
}

$(document).ready(function () {

    if ($('#noVNC_screen').length) {

        var host, port, password, path, token,
            inactivity,
            baseUrl = $('body').data('base-url'),
            isConnected = false,
            updateStatus,
            keepAlive,
            debugLog;

        $D('sendCtrlAltDelButton').style.display = "inline";
        $D('sendCtrlAltDelButton').onclick = sendCtrlAltDel;
        $D('xvpShutdownButton').onclick = xvpShutdown;
        $D('xvpRebootButton').onclick = xvpReboot;
        $D('xvpResetButton').onclick = xvpReset;

        WebUtil.init_logging(WebUtil.getQueryVar('logging', 'warn'));

        host = document.getElementById('host').value;
        port = document.getElementById('port').value;
        password = document.getElementById('password').value;

        // If a token variable is passed in, set the parameter in a cookie.
        // This is used by nova-novncproxy.
        token = WebUtil.getQueryVar('token', null);
        if (token) {
            WebUtil.createCookie('token', token, 1)
        }

        rfb = new RFB({
            'target': $D('noVNC_canvas'),
            'encrypt': WebUtil.getQueryVar('encrypt', (window.location.protocol === "https:")),
            'repeaterID': WebUtil.getQueryVar('repeaterID', ''),
            'true_color': WebUtil.getQueryVar('true_color', true),
            'local_cursor': WebUtil.getQueryVar('cursor', true),
            'shared': WebUtil.getQueryVar('shared', true),
            'view_only': WebUtil.getQueryVar('view_only', false),
            'updateState': updateState,
            'onXvpInit': xvpInit
        });

        updateStatus = function(status) {
            return $.post(
                baseUrl + '/vm/action/use',
                {
                    port: $('#port').val(),
                    status: status,
                    name: $('#vm-name').text()
                },
                function (response) {
                    return response;
                }
            );
        };

        inactivity = new Inactivity(function() {
            updateStatus('stop');
        });

        keepAlive = {
            interval: null,
            init: function () {
                this.interval = setInterval(this.save, 1000 * 60 * 5);
            },
            save: function () {
                $.get(baseUrl + '/vm/action/keep-alive-sockets');
            }
        };

        debugLog = function (logMessage, logObject) {
            if (window.debugMode && window.debugMode) {
                window.console.debug('VNC Controls: ' + logMessage);

                if (logObject) {
                    window.console.debug(logObject);
                }
            }
        };

        $('#noVNC_connect').click(function(e) {
            var def,
                $this = $(this);

            if (isConnected) {
                debugLog('Disconnecting');
                inactivity.destroy();
                rfb.disconnect();
                UI.disconnect();
                isConnected = false;
                updateStatus('stop');

                $this.find('.text').text('Start');
                $this.removeClass('btn-danger').addClass('btn-success');
            } else {
                debugLog('Connecting');
                def = updateStatus('start');

                $.when(def).done(function (response) {
                    debugLog('Response from updateStatus: ', response);

                    if (response.success) {
                        inactivity.init();
                        rfb.connect(host, port, password, '');
                        UI.start();
                        UI.connect();
                        isConnected = true;
                        keepAlive.init();

                        $this.find('.text').text('Stop');
                        $this.removeClass('btn-success').addClass('btn-danger');

                        $('#in-use-alert').css('display', 'none');

                    } else {

                        if (typeof response.lastUser !== undefined && response.lastUser !== null && response.lastUser.length > 0) {
                            $('#in-use-by').html(response.lastUser);
                        } else {
                            $('#in-use-by').html('an unknown user');
                        }

                        $('#in-use-alert').show();
                    }
                });
            }

            e.preventDefault();
        });
    }
});
